/**
 * Author: Qian.qianchen 2018-11-13
 * discription: 产品管理 微博 微博账号编辑
 */
'use strict';
angular.module('productManageMentEditWeiboModule', [])
    .controller('productManageMentEditWeiboCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation', 'itemRight', function($scope, $modalInstance, modalDialog, item, trsHttpService, $validation, itemRight) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {

            $scope.data = {
                currUser: {
                    accountId: item.ACCOUNTID,
                    sinaLoginUserName: item.USERID,
                    sinaUserLoginPwd: '',
                    checkFgdAttribute: item.CHECKFGDATTRIBUTE,
                    isAutoBind: item.ISAUTOBIND,
                    isRefrensh: 0,
                    ISORIGINAL: item.ISORIGINAL,
                    ISPAICHONG: item.ISPAICHONG,
                    CKMSIMDAYRANGE: item.CKMSIMDAYRANGE,
                }
            };
            $scope.status = {
                delayRight: itemRight
            };
            $scope.isJudge = item.ISORIGINAL == '1';
        }

        /**
         * [checkFgdEdit description]
         *
         * @return  {[type]}   [return description]
         */
        function checkFgdEdit() {
            var params = {
                serviceid: 'wcm61_scmaccount',
                methodname: 'editAccountCheckFgdDataToJson',
                AccountId: $scope.data.currUser.accountId,
                CheckFgdAttribute: $scope.data.currUser.checkFgdAttribute,
                ISORIGINAL: $scope.data.currUser.ISORIGINAL,
                ISPAICHONG: $scope.data.currUser.ISPAICHONG,
                CKMSIMDAYRANGE: $scope.data.currUser.CKMSIMDAYRANGE,
            };
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                $modalInstance.close('success');
            }, function(data) {
                $modalInstance.close(data);
            });
        }

        /**
         * [editInfo description]
         *
         * @return  {[type]}   [return description]
         */
        function editInfo() {
            var params = {
                serviceid: 'wcm61_scmaccount',
                methodname: 'addSinaAccountToJson',
                sinaLoginUserName: $scope.data.currUser.sinaLoginUserName,
                sinaUserLoginPwd: $scope.data.currUser.sinaUserLoginPwd,
                checkFgdAttribute: $scope.data.currUser.checkFgdAttribute,
                ISORIGINAL: $scope.data.currUser.ISORIGINAL,
                ISPAICHONG: $scope.data.currUser.ISPAICHONG,
                CKMSIMDAYRANGE: $scope.data.currUser.CKMSIMDAYRANGE,
            };
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(['./lib/js-base64/base64.js'], function() {
                    params.sinaUserLoginPwd = Base64.encode(angular.copy($scope.data.currUser.sinaUserLoginPwd));
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                        $modalInstance.close('success');
                    }, function(data) {
                        $modalInstance.close(data);
                    });
                });
            });
        }

        /**
         * [checkProperty description] 是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.data.currUser.checkFgdAttribute = $scope.data.currUser.checkFgdAttribute == '0' ? '1' : '0';
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            if ($scope.data.currUser.isAutoBind == '1') {
                editInfo();
            } else if ($scope.data.currUser.isRefrensh == '1') {
                refresh();
            } else {
                checkFgdEdit();
            }
            if ($scope.isJudge && $scope.data.currUser.ISORIGINAL == '0'){
                deleteProducts();
            }
        };

        /**
         * [deleteProducts description]
         *
         * @return  {[type]}   [return description]
         */
        function deleteProducts(){
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'deleteProduct',
                PRODUCTID: $scope.data.currUser.accountId,
                MEDIATYPE: 5
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(){

            });
        }

        /**
         * [refresh description] 微博手动延期
         * @return {[type]} [description]
         */
        function refresh() {
            window.open('/wcm/app/scm/sina_authorized.jsp?CheckFgdAttribute=' + $scope.data.currUser.checkFgdAttribute);
            $modalInstance.close('successNeedConfirm');
        }
    }]);
